import { commonMenuItems } from "./common";
import defaultProfile from "./default";
import type { GameProfile, ProfileCtx } from "./types";

export default (_ctx: ProfileCtx): Partial<GameProfile> => {
  const base = defaultProfile();
  // The server reads no console input, so there is no console page, only its log files.
  base.menu[0].items.push(commonMenuItems.logs);

  return {
    menu: base.menu,
    // No player count source yet: WukongMP speaks no query protocol the web-api knows (TR-5607).
    hasActivePlayers: false,
    // One port carries the game and the server's admin panel; nothing listens on query or rcon
    statusPageConfig: {
      ...base.statusPageConfig,
      showQueryPort: false,
      showRconPort: false,
    },
  };
};
